import { render, staticRenderFns } from "./Modeles.vue?vue&type=template&id=f4eb8e8a&"
import script from "./Modeles.vue?vue&type=script&lang=js&"
export * from "./Modeles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports